import { isArray, isObject } from "lodash-es"

const processArray = item => {
  return isArray(item) ? item : null
}

const processObject = item => {
  return isObject(item) ? [item.value, item.text, item.disabled, item.color] : null
}

const processScalar = item => [item, item]

export const processItems = (items) => items.map(item => {
  return processArray(item) ?? processObject(item) ?? processScalar(item)
})
